/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DomainService API
 * API reference for handling domain data provided by DomainService.
 *
 * # Authentication
 * This API is stateful. Therefore, it is necessary to call with the authentication information set in the cookie.
 * More specifically, it authenticates using Auth0.
 * Please set in header before calling API
 *  - x-solution-id
 *  - x-client-id
 *  - Authorization
 *  - Cookie.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  ArrangeRequest,
  BaseSuccessResponse,
  CreateUpdateDamageAttributeRequest,
  CreateUpdateDamageTypeRequest,
  DamageAttributeResponse,
  DamageAttributesResponse,
  DamageTypeResponse,
  DamageTypesResponse,
  ListDamageAttributesParams,
  ListDamageTypesParams
} from '../model';

import listDamageTypesMutator from '../../../mutators/domain-service-instance';
import storeDamageTypesMutator from '../../../mutators/domain-service-instance';
import updateDamageTypeMutator from '../../../mutators/domain-service-instance';
import deleteDamageTypeMutator from '../../../mutators/domain-service-instance';
import arrangeDamageTypeMutator from '../../../mutators/domain-service-instance';
import listDamageAttributesMutator from '../../../mutators/domain-service-instance';
import storeDamageAttributeMutator from '../../../mutators/domain-service-instance';
import updateDamageAttributeMutator from '../../../mutators/domain-service-instance';
import deleteDamageAttributeMutator from '../../../mutators/domain-service-instance';



  /**
 * Returns a list of damage types.
 * @summary List damage types
 */
export const listDamageTypes = (
    params?: ListDamageTypesParams,
 ) => {
      return listDamageTypesMutator<DamageTypesResponse>(
      {url: `/damage-types`, method: 'GET',
        params
    },
      );
    }
  /**
 * Store damage type. Damage type name must unique in one organization.
 * @summary Store damage type
 */
export const storeDamageTypes = (
    createUpdateDamageTypeRequest: CreateUpdateDamageTypeRequest,
 ) => {
      return storeDamageTypesMutator<DamageTypeResponse>(
      {url: `/damage-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateDamageTypeRequest
    },
      );
    }
  /**
 * Update damage type
 * @summary Update Damage Type
 */
export const updateDamageType = (
    id: number,
    createUpdateDamageTypeRequest: CreateUpdateDamageTypeRequest,
 ) => {
      return updateDamageTypeMutator<DamageTypeResponse>(
      {url: `/damage-types/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateDamageTypeRequest
    },
      );
    }
  /**
 * Delete damage type
 * @summary Delete Damage Type
 */
export const deleteDamageType = (
    id: number,
 ) => {
      return deleteDamageTypeMutator<BaseSuccessResponse>(
      {url: `/damage-types/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * Arrange damage types (sort order)
 * @summary Arrange Damage Types
 */
export const arrangeDamageType = (
    arrangeRequest: ArrangeRequest,
 ) => {
      return arrangeDamageTypeMutator<BaseSuccessResponse>(
      {url: `/damage-types/arrange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: arrangeRequest
    },
      );
    }
  /**
 * Returns a list of damage attributes.
 * @summary List damage attributes
 */
export const listDamageAttributes = (
    params?: ListDamageAttributesParams,
 ) => {
      return listDamageAttributesMutator<DamageAttributesResponse>(
      {url: `/damage-attributes`, method: 'GET',
        params
    },
      );
    }
  /**
 * Store damage attribute. Damage attribute name and value_display_name must unique in one organization.
 * @summary Store damage attribute
 */
export const storeDamageAttribute = (
    createUpdateDamageAttributeRequest: CreateUpdateDamageAttributeRequest,
 ) => {
      return storeDamageAttributeMutator<DamageAttributeResponse>(
      {url: `/damage-attributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateDamageAttributeRequest
    },
      );
    }
  /**
 * Update damage attribute
 * @summary Update Damage Attribute
 */
export const updateDamageAttribute = (
    id: number,
    createUpdateDamageAttributeRequest: CreateUpdateDamageAttributeRequest,
 ) => {
      return updateDamageAttributeMutator<DamageAttributeResponse>(
      {url: `/damage-attributes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateDamageAttributeRequest
    },
      );
    }
  /**
 * Delete damage attribute
 * @summary Delete Damage Attribute
 */
export const deleteDamageAttribute = (
    id: number,
 ) => {
      return deleteDamageAttributeMutator<BaseSuccessResponse>(
      {url: `/damage-attributes/${id}`, method: 'DELETE'
    },
      );
    }
  export type ListDamageTypesResult = NonNullable<Awaited<ReturnType<typeof listDamageTypes>>>
export type StoreDamageTypesResult = NonNullable<Awaited<ReturnType<typeof storeDamageTypes>>>
export type UpdateDamageTypeResult = NonNullable<Awaited<ReturnType<typeof updateDamageType>>>
export type DeleteDamageTypeResult = NonNullable<Awaited<ReturnType<typeof deleteDamageType>>>
export type ArrangeDamageTypeResult = NonNullable<Awaited<ReturnType<typeof arrangeDamageType>>>
export type ListDamageAttributesResult = NonNullable<Awaited<ReturnType<typeof listDamageAttributes>>>
export type StoreDamageAttributeResult = NonNullable<Awaited<ReturnType<typeof storeDamageAttribute>>>
export type UpdateDamageAttributeResult = NonNullable<Awaited<ReturnType<typeof updateDamageAttribute>>>
export type DeleteDamageAttributeResult = NonNullable<Awaited<ReturnType<typeof deleteDamageAttribute>>>
